import React from 'react';
import {
  TextField,
  Typography,
  Grid,
  Paper,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
} from '@mui/material';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import SearchBarDropdown from '../../SearchBarDropdown';
import { SESSION_LENGTH } from '../constants/index';

const TimeOfSessionCard = ({
  date,
  time,
  endTime,
  sessionLength,
  customSessionLength,
  sessionAttended,
  onFieldChange,
}) => {
  return (
    <Paper
      elevation={2}
      sx={{
        p: 3,
        borderRadius: 3,
        backgroundColor: 'white',
        fontFamily: 'Lato, sans-serif',
      }}
    >
      <Typography
        variant='h6'
        sx={{ mb: 2, color: '#9291f0', fontWeight: 600 }}
      >
        Time of Session
      </Typography>
      <Grid container spacing={3}>
        {/* Date */}
        <Grid item xs={12} sm={4}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label='Date'
              value={date ? dayjs(date) : dayjs()}
              onChange={(newValue) => {
                if (newValue) {
                  const formattedDate = newValue.format('YYYY-MM-DD');
                  onFieldChange('date', formattedDate);
                }
              }}
              maxDate={dayjs()}
              renderInput={(params) => (
                <TextField {...params} fullWidth variant='outlined' />
              )}
              sx={{ width: '100%' }}
            />
          </LocalizationProvider>
        </Grid>

        <Grid item xs={12} sm={4}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <TimePicker
              label='Start Time'
              value={time || null}
              sx={{ width: '100%' }}
              onChange={(newValue) => onFieldChange('time', newValue)}
              ampm={true}
              views={['hours', 'minutes', 'seconds']}
              format='hh:mm A'
              renderInput={(params) => (
                <TextField {...params} fullWidth variant='outlined' />
              )}
            />
          </LocalizationProvider>
        </Grid>

        <Grid item xs={12} sm={4}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <TimePicker
              label='End Time'
              value={endTime || null}
              sx={{ width: '100%' }}
              onChange={(newValue) => onFieldChange('endTime', newValue)}
              ampm={true}
              views={['hours', 'minutes', 'seconds']}
              format='hh:mm A'
              renderInput={(params) => (
                <TextField {...params} fullWidth variant='outlined' />
              )}
            />
          </LocalizationProvider>
        </Grid>

        {/* Session Length Dropdown */}
        <Grid item xs={12} sm={4}>
          <SearchBarDropdown
            options={SESSION_LENGTH}
            value={sessionLength}
            onChange={(selectedValue) => {
              onFieldChange('sessionLength', selectedValue);
              if (selectedValue !== 'Other') {
                onFieldChange('customSessionLength', '');
              }
            }}
            label='Session Length'
            sx={{ width: '100%' }}
            message='Select a session length'
          />
        </Grid>

        <Grid item xs={12} sm={4}>
          <FormControl component='fieldset' sx={{ width: '100%' }}>
            <FormLabel
              component='legend'
              sx={{ mb: 1, fontSize: 14, color: 'rgba(0, 0, 0, 0.6)' }}
            >
              Session Attended
            </FormLabel>
            <RadioGroup
              row
              name='sessionAttended'
              value={sessionAttended || ''}
              onChange={(event) =>
                onFieldChange('sessionAttended', event.target.value)
              }
            >
              <FormControlLabel value='Yes' control={<Radio />} label='Yes' />
              <FormControlLabel value='No' control={<Radio />} label='No' />
            </RadioGroup>
          </FormControl>
        </Grid>

        {sessionLength === 'Other' && (
          <Grid item xs={12} sm={8}>
            <TextField
              label='Units'
              type='number'
              inputProps={{ min: 1, step: 1 }}
              fullWidth
              value={customSessionLength || ''}
              onChange={(e) => {
                const units = e.target.value === '' ? '' : parseInt(e.target.value, 10);
                onFieldChange('customSessionLength', units);
              }}
              placeholder='Enter number of units (1 unit = 15 minutes)'
              variant='outlined'
              sx={{ backgroundColor: '#f9f9ff' }}
              helperText='1 unit = 15 minutes'
            />
          </Grid>
        )}
      </Grid>
    </Paper>
  );
};

export default TimeOfSessionCard;